import { Components, Theme, alpha } from '@mui/material';

const components: Components<Omit<Theme, 'components'>>['MuiTextField'] = {
  styleOverrides: {
    root: ({ theme: { palette, spacing } }) => {
      const isLight = palette.mode === 'light';
      return {
        '& > div.MuiInputBase-root > fieldset': {
          border: 0
        },
        '& > div.MuiInputBase-root': {
          borderRadius: '6px',
          gap: spacing(1),
          transition: 'all 0.2s',
          padding: spacing(2.5, 3),
          border: isLight
            ? `1px solid ${palette.grayBackground.A40}`
            : `1px solid ${palette.secondary.A100}`,
          backgroundColor: isLight ? palette.base.A0 : palette.secondary.A100,
          '&:hover': {
            border: isLight
              ? `1px solid ${palette.grayBackground.A40}`
              : `1px solid ${palette.base.A60}`,
            backgroundColor: isLight ? palette.base.A0 : palette.base.A60
          },
          '&.Mui-focused': {
            border: isLight
              ? `1px dashed ${palette.primary.A100}`
              : `1px solid ${palette.primary.A80}`,
            backgroundColor: isLight ? palette.base.A0 : palette.base.A60
          },
          '&.Mui-error': {
            border: isLight
              ? `1px solid ${palette.error.A100}`
              : `1px solid ${palette.error.A60}`,
            backgroundColor: isLight
              ? palette.error.A20
              : alpha(palette.error.A100 || '', 0.1)
          },
          '&.Mui-disabled': {
            borderColor: isLight
              ? palette.grayBackground.A40
              : palette.secondary.A100,
            backgroundColor: isLight
              ? palette.grayBackground.A10
              : palette.secondary.A100
          }
        },
        '& > div.MuiInputBase-root > input.MuiInputBase-input': {
          color: isLight ? palette.textColor.A80 : palette.textColor.A0,
          padding: spacing(0),
          '&.Mui-disabled': {
            textFillColor: isLight
              ? palette.textColor.A40
              : palette.textColor.A50
          }
        },
        '& > div.MuiInputBase-root > input.MuiInputBase-input.Mui-disabled': {
          textFillColor: isLight ? palette.textColor.A40 : palette.textColor.A50
        }
      };
    }
  }
};

export default {
  components
};
